/* eslint-disable sonarjs/no-duplicate-string */
import { IconProps } from '@alto-avios/alto-ui/dist/components/Icon/Icon'

export const convertServiceToIcon = (service: string | undefined): IconProps => {
  let iconProps: IconProps = {
    iconName: 'car',
    iconPrefix: 'far',
  }

  switch (service) {
    case 'ADD':
      iconProps.iconName = 'user'
      break
    case 'ADR':
      iconProps.iconName = 'user'
      break
    case 'ATC':
      iconProps.iconName = 'money-from-bracket'
      break
    case 'ATP':
      iconProps.iconName = 'bridge'
      break
    case 'BBS':
      iconProps.iconName = 'child-reaching'
      break
    case 'BKR':
      iconProps.iconName = 'bicycle'
      break
    case 'CBS':
      iconProps.iconName = 'person-seat'
      break
    case 'CIS':
      iconProps.iconName = 'child-reaching'
      break
    case 'CNP':
      iconProps.iconName = 'leaf-heart'
      break
    case 'CSS':
      iconProps.iconName = 'person-seat'
      break
    case 'DIE':
      iconProps.iconName = 'gas-pump'
      break
    case 'GPS':
      iconProps.iconName = 'location-dot'
      break
    case 'IXB':
      iconProps = { iconName: 'person-seat', iconPrefix: 'fas' }
      break
    case 'NAV':
      iconProps.iconName = 'location-dot'
      break
    case 'RSN':
      iconProps.iconName = 'car-wrench'
      break
    case 'SKR':
      iconProps.iconName = 'person-ski-lift'
      break
    case 'SNC':
      iconProps.iconName = 'tire-rugged'
      break
    case 'TAB':
      iconProps.iconName = 'crosshairs-simple'
      break
    case 'TCT':
      iconProps.iconName = 'laptop-mobile'
      break
    case 'TPR':
      iconProps.iconName = 'user-tie'
      break
    case 'VSS':
      iconProps.iconName = 'shield-check'
      break
    case 'WFI':
      iconProps.iconName = 'wifi'
      break
    default:
      iconProps = { iconName: 'car', iconPrefix: 'fas' }
  }

  return iconProps
}
